import request from "@/utils/request";

export function getPage(condition, pagination) {
  return request({
    url: "/customer/customerApply/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function getSalesOrganization(condition, pagination) {
  return request({
    url: "/base/salesOrganization/pagePopup",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function saveOrUpdate(data) {
  return request({
    url: "/customer/customerApply/saveOrUpdate",
    method: "post",
    data,
  });
}

export function get(id) {
  return request({
    url: "/customer/customerApply/get",
    method: "get",
    params: { id },
  });
}

export function deleteById(id) {
  return request({
    url: "/customer/customerApply/deleteById",
    method: "post",
    data: { id: id },
  });
}

export function exportExcel(condition, pagination) {
  return request({
    url: "/customer/customerApply/exportExcel",
    method: "post",
    data: { condition: condition, pagination: pagination },
    responseType: "blob",
  });
}
// 获取省市
export function areaList(data) {
  return request({
    url: "/customer/customerApply/areaList",
    method: "post",
    data,
  });
}

export function submit(id) {
  return request({
    url: "/customer/customerApply/submit",
    method: "post",
    data: { id: id },
  });
}

export function page(condition, pagination) {
  return request({
    url: "/system/admin/getByRoleCode",
    method: "post",
    data: { condition, pagination },
  });
}

export function callSap(id) {
  return request({
    url: "/customer/customerApply/callSap",
    method: "post",
    data: { id: id },
  });
}
// 下载模版
export function downloadTemplate() {
  return request({
    url: '/customer/customerApply/downloadTemplate',
    method: 'post',
    responseType: 'blob'
  })
}
// 导入
export function uploadFile(formData) {
  return request({
    url: "/customer/customerApply/excelImport",
    method: "post",
    data: formData,
  });
}
// 投标客户
export function appSaveOrUpdate(data) {
  return request({
    url: "/customer/customerApply/appSaveOrUpdate",
    method: "post",
    data,
  });
}